import { FeatureDto } from "../interface/Features";
import { ALL_PAGE_KEYS, ALWAYS_ENABLED_KEYS } from "../interface/Pagesconfig"

export { ALL_PAGE_KEYS };


export const PAGE_FEATURE_MAP: Record<string, string[]> = {
  dashboard: [],
  medicalicd: [],
  medicalactivity: [],

  customicd: ["CUSTOM_ICD_GROUP"],
  customactivity: ["CUSTOM_ACTIVITY_GROUP"],

  "icd-not-covered": ["ICD_RULES.NOT_COVERED"],
  "icd-not-allowed-principal": ["ICD_RULES.NOT_ALLOWED_PRINCIPAL"],
  "icd-age-gender": ["ICD_RULES.AGE_GENDER"],

  "activity-not-covered": ["ACTIVITY_RULES.NOT_COVERED"],
  "activity-age-gender": ["ACTIVITY_RULES.AGE_GENDER"],
  "activities-not-allowed": ["ACTIVITY_RULES.NOT_ALLOWED_WITH_ACTIVITY"],
  "activities-allowed": ["ACTIVITY_RULES.ACTIVITIES_TOGETHER"],
  "activity-not-allowed-icd": ["ACTIVITY_RULES.NOT_ALLOWED_WITH_ICD"],
  "activity-pre-approvals": ["ACTIVITY_RULES.PRE_APPROVAL"],
  "activity-supporting-docs": ["ACTIVITY_RULES.SUPPORTING_DOCS"],
  "activity-frequency": ["ACTIVITY_RULES.FREQUENCY_LIMIT"],
 "activity-bundle": ["ACTIVITY_RULES.ACTIVITY_BUNDLE"],

  "tpa-payer": ["TPA", "PAYER"],
  "network-plan": ["NETWORK"],
  policy: ["POLICY"],
  specialty: ["SPECIALITY"],
  doctor: ["DOCTOR"],

  "claim-validation": ["CLAIM_VALIDATION"],
  "bulk-claim-validation": ["CLAIM_VALIDATION"],
  "claim-validation-history": ["CLAIM_VALIDATION"],
};

/* =========================
   Helpers
========================= */

export const buildCodeToFeatureMap = (
  features: FeatureDto[]
): Map<string, FeatureDto> => {
  const map = new Map<string, FeatureDto>();
  if (!Array.isArray(features)) return map;
  features.forEach((f) => map.set(f.code, f));
  return map;
};


export const isAlwaysEnabled = (pageKey: string): boolean => {
  if (ALWAYS_ENABLED_KEYS.includes(pageKey)) return true;
  const codes = PAGE_FEATURE_MAP[pageKey];
  return !codes || codes.length === 0;
};


export const getPageEnabledState = (
  pageKey: string,
  codeToFeature: Map<string, FeatureDto>,
  enabledFeatureIds: Set<string>
): boolean => {
  if (isAlwaysEnabled(pageKey)) return true;

  const codes = PAGE_FEATURE_MAP[pageKey] ?? [];
  return codes.every((code) => {
    const feature = codeToFeature.get(code);
    if (!feature) return false; 
    return enabledFeatureIds.has(feature.id);
  });
};

export const getFeatureIdsForPage = (
  pageKey: string,
  codeToFeature: Map<string, FeatureDto>
): string[] => {
  const codes = PAGE_FEATURE_MAP[pageKey] ?? [];
  return codes
    .map((code) => codeToFeature.get(code)?.id)
    .filter((id): id is string => Boolean(id));
};